import { FormControl, FormGroup } from '@angular/forms';
import { IReservation } from '@internal-models/reservation.model';
import { Action } from '@shared-libs/enums';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup } from '@shared-libs/interfaces';
import { ClientFormFactory } from './client-form.factory';
import { CommunicationFormFactory } from './communication-form.factory';
import { IWaitListItem } from '@internal-models/wait-list-item.model';

export class ReservationFormFactory {
	public static create(
		reservation?: IReservation,
		action: Action = Action.CREATE,
		isInPast: boolean = false,
		waitListItem?: IWaitListItem
	): IFormGroup<IReservation> {
		return new FormGroup({
			id: new FormControl(reservation?.id),
			question: new FormControl(reservation?.question ?? waitListItem?.description),
			replyTo: new FormControl(reservation?.replyTo, [SharedFormValidators.email]),
			telephone: new FormControl(reservation?.telephone, [SharedFormValidators.phone]),
			DeviceTypeId: new FormControl(reservation?.DeviceTypeId),
			digibankObjective: new FormControl(reservation?.digibankObjective),
			Communication: CommunicationFormFactory.create(!isInPast),
			...(action === Action.CREATE
				? { Client: ClientFormFactory.createForReservation(reservation?.Client ?? waitListItem?.Client) }
				: {}),
			Attendance: new FormGroup({
				id: new FormControl(reservation?.Attendance?.id),
				QuestionCategories: new FormControl(
					(reservation?.Attendance?.QuestionCategories || []).map((category) => category.id),
					[SharedFormValidators.required]
				),
			}),
			WaitListItemId: new FormControl(waitListItem?.id),
		}) as IFormGroup;
	}

	public static getValue(reservationForm: IFormGroup<IReservation>): Partial<IReservation> {
		const clientForm = reservationForm.get('Client') as IFormGroup;
		return {
			...reservationForm.value,
			...(clientForm ? { Client: ClientFormFactory.getValue(clientForm) } : {}),
		};
	}
}
